import { createAction } from '@reduxjs/toolkit';

export const CHANGE_PARTICIPANTS_ACTION_TYPE = 'saga/changeParticipants';
export const changeParticipantsAction = createAction(CHANGE_PARTICIPANTS_ACTION_TYPE);
